import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import { Module } from '@/modules/companies/consts'
import { ExportFleetTaxZoneCard, TaxUnitSettings } from '../components'
import {
  Header,
  InfoBox,
  OldSection,
  SectionHeader,
  SettingsWrapper,
} from '../components/common'
import { ModuleOptionCards } from '../components/ModuleOptionCards'

export const EmployerTaxSettings: React.FC = () => {
  const translations = useTranslate({
    info: 'settings.info.employer-tax',
    rules: 'settings.employer-tax.rules',
    rulesInfo: 'settings.employer-tax.rules-info',
  })

  return (
    <SettingsWrapper grid={{ flow: 'row' }}>
      <InfoBox>
        <p>{translations.info}</p>
      </InfoBox>

      <TaxUnitSettings />

      <OldSection>
        <Header>
          <SectionHeader>{translations.rules}</SectionHeader>
        </Header>

        <p className="mb-4 text-sm text-stone-500">{translations.rulesInfo}</p>

        <ModuleOptionCards module={Module.EMPLOYER_TAX} />
      </OldSection>

      <ExportFleetTaxZoneCard />
    </SettingsWrapper>
  )
}
